import { render, staticRenderFns } from "./GlobalAdvanceAndLoans.vue?vue&type=template&id=0688554b&scoped=true"
import script from "./GlobalAdvanceAndLoans.vue?vue&type=script&lang=js"
export * from "./GlobalAdvanceAndLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0688554b",
  null
  
)

export default component.exports